export default __webpack_public_path__ + "static/media/service-center.bd62fc7e.svg";